<script>
import EventSalesFilter from "@/components/sale/EventSalesFilter.vue";
import SalesBase from "./SalesBase.vue";

export default {
  extends: SalesBase,
  data() {
    return {
      filterModal: EventSalesFilter,
      product_type: "onsite_event"
    };
  }
};
</script>
